module.exports = __webpack_public_path__ + "static/media/19a-05_ST-2019-200x180cm-oleo-sobre-madera.35ece503.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/19a/19a-05_ST-2019-200x180cm-oleo-sobre-madera.jpg
// module id = 240
// module chunks = 0